import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CACHE_SERVICE } from './cache.service';

@Injectable({
  providedIn: 'root',
})
export class CacheInterceptor implements HttpInterceptor {
  readonly cacheSvc = inject(CACHE_SERVICE);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return this.cacheSvc.intercept(req, next);
  }
}
